import Vue from "vue";

const internalEventBus = new Vue();

export default {
    $on: function (event, callback) {
        // we want to make sure that each event emitted is received only
        // once, so we will any existing callback first and then
        // subscribe to the new event.
        internalEventBus.$off(event);
        internalEventBus.$on(event, callback);
    },

    $off: function () {
        internalEventBus.$off.apply(internalEventBus, arguments);
    },

    $emit: function () {
        internalEventBus.$emit.apply(internalEventBus, arguments);
    }
};
